import React, {useEffect} from 'react';
import Carousel from '../../Atoms/Carousel/Carousel';
import logo from './Assets/logo.png';
import menuElements from './Assets/MenuElements'
import ToTopArrow from '../../Atoms/ToTopArrow/ToTopArrow';
import './Menu2.scss';

const Menu2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add('no-chat');
    return () => {
      document.body.classList.add('no-chat');
    }
  }, []);

  return(
    <div className='page menu2'>
      <div className='container'>
      <div className='brand-wrapper'>
        <img src={logo} alt="Oshayima" />
      </div>
      <div className='menu-content'>
        <Carousel elements={menuElements[0].contenido_seccion}/>
        <section>
          <span className='section-title'><i className='roll'/>{menuElements[1].titulo_seccion}</span>
          <ul>
            {menuElements[1].contenido_seccion.map(item =>
              <li key={item.id}>
                <div className='row'>
                  <span className='title'>{item.titulo}</span>
                  <span className='price'>${item.precio}</span>
                </div>
                <span className='description'>{item.descripcion}</span>
              </li>
            )}
          </ul>
        </section>
        <section>
          <span className='section-title'><i className='tei-wok'/>{menuElements[2].titulo_seccion}</span>
          <ul>
            {menuElements[2].contenido_seccion.map(item =>
              <li key={item.id}>
                <div className='row'>
                  <span className='title'>{item.titulo}</span>
                  <span className='price'>${item.precio}</span>
                </div>
                <span className='description'>{item.descripcion}</span>
              </li>
            )}
          </ul>
        </section>
        <section>
          <span className='section-title'><i className='drinks'/>{menuElements[3].titulo_seccion}</span>
          <ul>
            {menuElements[3].contenido_seccion.map(item =>
              <li key={item.id}>
                <div className='row'>
                  <span className='title'>{item.titulo}</span>
                  <span className='price'>${item.precio}</span>
                </div>
                <span className='description'>{item.descripcion}</span>
              </li>
            )}
          </ul>
        </section>
      </div>
      </div>
      <ToTopArrow />
    </div>
  );
};

export default Menu2;